import { useViewSistema } from '../../../hooks/useView'
import { FormProvider } from '../../../hooks/useForm'
import { lazy, Suspense } from 'react'
import { LoaderSuspense } from '../loader/LoaderSuspense'
import '../util/Custom.css'

const listaViews = {
    agenda: lazy(() => import('../../../modulos/agenda/FormAgenda').then(module => { return { default: module.FormAgenda } })),
    eventos_por_recurso: lazy(() => import('../../../modulos/relatorios/FormRelatorioEventosPorRecurso').then(module => { return { default: module.FormRelatorioEventosPorRecurso } })),
    meus_dados: lazy(() => import('../../../modulos/cadastro/meus_dados/FormMeusDados').then(module => { return { default: module.FormMeusDados } })),
    pessoas: lazy(() => import('../../../modulos/cadastro/pessoa/FormPessoa').then(module => { return { default: module.FormPessoa } })),
    pessoas_com_eventos: lazy(() => import('../../../modulos/relatorios/FormRelatorioPessoasComEventos').then(module => { return { default: module.FormRelatorioPessoasComEventos } })),
    prontuarios: lazy(() => import('../../../modulos/tratamento/prontuario/FormProntuario').then(module => { return { default: module.FormProntuario } })),
    recursos: lazy(() => import('../../../modulos/cadastro/recurso/FormRecurso').then(module => { return { default: module.FormRecurso } })),
    usuarios: lazy(() => import('../../../modulos/admin/usuario/FormUsuario').then(module => { return { default: module.FormUsuario } })),
}

const listaViewsGenericas = {
    cancers: {
        nomeForm: 'Cancer', 
        artigo: 'o'
    },
    cids: {
        nomeForm: 'CID', 
        artigo: 'o'
    },
    escolaridades: {
        nomeForm: 'Escolaridade', 
        artigo: 'a'
    },
    medicamentos: {
        nomeForm: 'Medicamento', 
        artigo: 'o'
    },
    patologias: {
        nomeForm: 'Patologia', 
        artigo: 'a'
    },
    substancias: {
        nomeForm: 'Substância', 
        artigo: 'a'
    },
    tipos_anexo: {
        nomeForm: 'Tipo de Anexo', 
        artigo: 'o',
    },
}

function renderViews(views = []) {
    return views.map((f) => {
        const parametrosFormGenerico = listaViewsGenericas[f.chave]
        const CurrentView = (!parametrosFormGenerico ? listaViews[f.chave] : lazy(() => import('../../../modulos/form_generico/FormGenerico').then(module => { return { default: module.FormGenerico } })))

        return (
            <div
                key={f.chave}
                className={`tab-pane fade${(f.ativo ? " active show" : "")}`}
                id={`tab-${f.chave}`}
                aria-labelledby={`tab-menu-${f.chave}`}>
                    <FormProvider idForm={f.chave} tituloForm={f.titulo}>
                        {((CurrentView ?? parametrosFormGenerico) ? <CurrentView key={f.chave} {...f.parametros} {...parametrosFormGenerico} permissoes={f.permissoes} /> : <></>)}
                    </FormProvider>
            </div>
        )
    })
}

export function ViewGerencia(){
    const { views } = useViewSistema()
    return (
        <div className="content-wrapper">
            <div className="card-body pt-0 pl-0">
                <div className="tab-content" id="menu-tabContent">
                    <Suspense fallback={<LoaderSuspense />}>
                        {renderViews(views)}
                    </Suspense>
                </div>
            </div>
        </div>
    )
}